<template>
    <div :style="{ width: changeWidth, backgroundColor: isActive ? '#210f03' : unActiveColor }" @click="btnClickEvent" class="common_btn">{{ btnName }}</div>
</template>

<script>
export default {
    name: "CommonBottomBtn",
    props: {
        btnClickEvent: {
            type: Function,
            default: () => { }
        },
        btnName: {
            type: String,
            default: ''
        },
        changeWidth: {
            type: String,
            default: ''
        },
        isActive: {
            type: Boolean,
            default: true
        },
        unActiveColor: {
            type: String,
            default: ''
        }
    }
};
</script>

<style scoped>
.common_btn {
    border-radius: 12px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background-color: #210f03;
    margin: 0 auto;
    margin-top: 12px;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
}
</style>
